import type { AddressUsage } from '~/api/DeliveryAddress';

import { resolveAddressUsage } from './addressUsage';

/**
 * Where the order is delivered to: the customer's own address or a pickup
 * point. Companies whose PUDO and courier deliveries share one
 * `delivery_method` send this with the ETA and the order, so the backend picks
 * the zone of the type the customer chose instead of guessing by geometry —
 * PUDO and courier zones overlap, so coordinates alone are ambiguous.
 */
export type DestinationKind = 'pup' | 'customer';

export type ETADestinationKind = DestinationKind | 'partner_pup';

/**
 * Maps the address fulfilment tag onto the destination the backend expects. An
 * untagged address resolves through the tenant default, so a locker saved
 * before tagging existed is not sent as a customer address.
 */
export const destinationKindForUsage = (
  usage: AddressUsage | undefined,
): DestinationKind =>
  resolveAddressUsage(usage) === 'pickup' ? 'pup' : 'customer';
